import type { Plan } from '@kontor/shared';
import { PLAN_LABELS } from '@kontor/shared';
import './planicon.css';

/**
 * Sinnbild je Paket: Basic ist ein Keimling (der Einstieg), Standard ein Schild mit Haken (das solide Paket für den Alltag), Premium eine Krone. Die Linien nutzen
 * currentColor, die Farbe kommt aus planicon.css (grün, blau, gold, auch im dunklen Design gut lesbar).
 */
export function PlanIcon({ plan, size = 18, className = '', title }: { plan: string; size?: number; className?: string; title?: boolean }) {
  const key = (plan === 'standard' || plan === 'premium' ? plan : 'basic') as Plan;
  const label = PLAN_LABELS[key];
  return (
    <svg
      className={`plan-icon plan-icon--${key} ${className}`.trim()}
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      role={title ? 'img' : undefined}
      aria-label={title ? `Paket ${label}` : undefined}
      aria-hidden={title ? undefined : true}
    >
      {key === 'basic' && (
        <>
          <path d="M12 21v-9" />
          <path d="M12 12c0-3.6-2.6-6.2-7-6.2 0 3.6 2.6 6.2 7 6.2Z" />
          <path d="M12 14.5c0-3.1 2.1-5.5 6.2-5.5 0 3.1-2.1 5.5-6.2 5.5Z" />
        </>
      )}
      {key === 'standard' && (
        <>
          <path d="M12 3 4.5 6v5.6c0 4.6 3.1 8 7.5 9.4 4.4-1.4 7.5-4.8 7.5-9.4V6L12 3Z" />
          <path d="m8.8 12.2 2.3 2.3 4.2-4.6" />
        </>
      )}
      {key === 'premium' && (
        <>
          <path d="m3 8 4.6 4L12 5l4.4 7L21 8l-2 11H5L3 8Z" />
          <path d="M5.5 19h13" />
        </>
      )}
    </svg>
  );
}
